"use strict";
// Comaprator for sorting strings nested within an object
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringSort = void 0;
function stringSort(get) {
    return (a, b) => {
        const str_a = get(a);
        const str_b = get(b);
        return str_a > str_b ? 1 : str_a < str_b ? -1 : 0;
    };
}
exports.stringSort = stringSort;
//# sourceMappingURL=stringSort.js.map